import React from 'react'

const Footer = () => {
  return (
    <footer className="footer-section relative footer-shape p-16 text-gray-400">
      <div className="container mx-auto relative px-4 z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-8">
          <div className="footer-widget xl:flex xl:flex-col xl:justify-center xl:col-span-2">
            <a
              className="font-coiny mb-8 text-xl md:text-3xl font-bold"
              href="/#"
            >
              
              SKULLA
            </a>
            <div className="social-share flex items-center">
              <a
                className="flex items-center justify-center w-10 h-10 bg-blueGray-200 rounded-lg border border-blueGray-200 transition duration-500 hover:bg-indigo-500 mr-2"
                href="#"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="36"
                  height="36"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"
                    fill="rgba(236,240,241,1)"
                  />
                </svg>
              </a>
              <a
                className="flex items-center justify-center w-10 h-10 bg-blueGray-200 rounded-lg border border-blueGray-200 transition duration-500 hover:bg-indigo-500 mr-2"
                href="#"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="36"
                  height="36"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z"
                    fill="rgba(236,240,241,1)"
                  />
                </svg>
              </a>
              <a
                className="flex items-center justify-center w-10 h-10 bg-blueGray-200 rounded-lg border border-blueGray-200 transition duration-500 hover:bg-indigo-500 mr-2"
                href="#"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 0 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" fill="rgba(236,240,241,1)"/></svg>
              </a>
              <a
                className="flex items-center justify-center w-10 h-10 bg-blueGray-200 rounded-lg border border-blueGray-200 transition duration-500 hover:bg-indigo-500 mr-2"
                href="#"
              >
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36"><path fill="none" d="M0 0h24v24H0z"/><path d="M18.335 18.339H15.67v-4.177c0-.996-.02-2.278-1.39-2.278-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387 2.7 0 3.2 1.778 3.2 4.091v4.715zM7.003 8.575a1.546 1.546 0 0 1-1.548-1.549 1.548 1.548 0 1 1 1.547 1.549zm1.336 9.764H5.666V9.75H8.34v8.589zM19.67 3H4.329C3.593 3 3 3.58 3 4.297v15.406C3 20.42 3.594 21 4.328 21h15.338C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3h.003z" fill="rgba(236,240,241,1)"/></svg>
              </a>
            </div>
          </div>
          <div className="footer-widget pb-4 lg:pb-0 lg:border-b-0 border-b border-indigo-200">
            <h4 className="font-display text-xl text-blueGray-900 font-semibold">
              Navigation
            </h4>
            <ul className="mt-4 xl:mt-10 flex flex-wrap xl:block">
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/"
                >
                  Home
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/explore"
                >
                  Explore
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/wallet"
                >
                  Wallet
                </a>
              </li>

              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/term-condition"
                >
                  Terms{' '}
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-widget pb-4 lg:pb-0 lg:border-b-0 border-b border-indigo-200">
            <h4 className="font-display text-xl text-blueGray-900 font-semibold">
              Explore
            </h4>
            <ul className="mt-4 xl:mt-10 flex flex-wrap xl:block">
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/explore"
                >
                  Explore Artwork
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/item-single"
                >
                  Artwork History
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/leaderboard"
                >
                  Explore Trends
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="#"
                >
                  Community
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-widget pb-4 lg:pb-0 lg:border-b-0 border-b border-indigo-200">
            <h4 className="font-display text-xl text-blueGray-900 font-semibold">
              Community
            </h4>
            <ul className="mt-4 xl:mt-10 flex flex-wrap xl:block">
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/mint"
                >
                 Mint Page
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/item-single2"
                >
                  Howto Mint
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/activity"
                >
                  Activity
                </a>
              </li>
              <li className="mb-4 mr-4">
                <a
                  className="font-body text-blueGray-600 transition duration-500 hover:text-indigo-500 underline-hover"
                  href="/#/contact"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-widget col-span-1 md:col-span-2">
            <h4 className="font-display text-xl text-blueGray-900 font-semibold">
              Subscribe Us
            </h4>
            <form className="footer-newsletter flex items-center w-full mb-4 mt-4 xl:mt-10">
              <input
                className="bg-transparent border-2 border-r-0 border-blue-500 transition duration-500 focus:outline-none hover:bg-white rounded-l w-full h-14 p-4"
                type="text"
                placeholder="Your e-mail address"
              />
              <button
                className="flex items-center rounded-r h-14 py-4 px-8 transition-all duration-500 bg-gradient-to-tl from-blue-500 via-purple-500 to-blue-500 bg-size-200 bg-pos-0 hover:bg-pos-100"
                type="submit"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.438l18.462 10.154a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154V13z" fill="rgba(236,240,241,1)"/></svg>
              </button>
            </form>
            <p className="font-body text-sm text-blueGray-600">
              Your privacy protected! We dont disclose Email.
            </p>
          </div>
        </div>
        <div className="lg:text-center mt-8 lg:mt-14">
          <p className="font-body text-sm text-blueGray-600">
            © <span id="spanYear">2022</span> Skulla - All Rights Reserved by{' '}
            <a
              href="https://designcoder.netlify.app"
              className="text-indigo-500 underline-hover"
              rel="noopener"
              target="_blank"
            >
              Simanta
            </a>
          </p>
        </div>
      </div>
      <a
        href="#top"
        className="footer-back w-10 h-10 hidden fixed bottom-8 right-8 z-50 bg-blueGray-600 rounded-lg items-center justify-center show"
      >
        <svg
          width={18}
          height={10}
          viewBox="0 0 18 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 9L9 1L17 9"
            stroke="white"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </footer>
  )
}

export default Footer
